import { withStageProjection } from "./commercialTracking.mjs";

const roots = { leads:"leads", kanban:"arflow_clients", prospeccao:"arflow_prospeccao" };
const phone = value => {
  let digits=String(value||"").replace(/\D/g,"");
  if(digits.length>11&&digits.startsWith("55"))digits=digits.slice(2);
  return digits.length===10?`${digits.slice(0,2)}9${digits.slice(2)}`:digits;
};
export function confirmedBindingForCard(moduleId, record, sales = []) {
  const key=String(record?._rawPhone||record?._firebaseKey||record?.id||"").replace(/^aurora_/,"");
  const store=Number(record?.lojaAtual||record?.storeId);
  const sourcePath=`${roots[moduleId]}/${key}`;
  const owner=Number(record?.consultantId||record?.consultorAtual);
  const matches=b=>b?.status==="confirmed"&&b.sourcePath===sourcePath
    && Number(b.storeId)===store&&!!b.pedidoId
    && (!b.consultantId||!owner||Number(b.consultantId)===owner)
    && (!b.phone||!phone(record?.telefone||record?.phone)
      ||phone(b.phone)===phone(record.telefone||record.phone));
  const bindingForSale=s=>{
    const candidates=[s.manualCardBinding,s.vinculo?.crmOriginBinding,
      ...(s.vinculoVendaExplicita?.leadChave&&s.classificacaoOrigem?.bindingStatus!=="pending"
        ?[{...s.vinculoVendaExplicita,status:"confirmed",sourcePath:`leads/${s.vinculoVendaExplicita.leadChave}`}]:[])];
    const candidate=candidates.find(b=>b?.status==="confirmed"&&b.sourcePath===sourcePath);
    return candidate?{...candidate,pedidoId:String(candidate.pedidoId||candidate.liftPedidoId||s.liftPedidoId),
      storeId:Number(candidate.storeId||s.storeId),saleDate:candidate.saleDate||s.dataVenda,
      saleValue:candidate.saleValue??s.valorTotal}:null;
  };
  const related=sales.filter(s=>Number(s.storeId)===store
    && (s.manualCardBinding?.sourcePath===sourcePath
      ||s.vinculo?.crmOriginBinding?.sourcePath===sourcePath
      ||(moduleId==="leads"&&s.vinculoVendaExplicita?.leadChave===key)
      ||String(s.liftPedidoId)===String(record?.manualSaleBinding?.pedidoId)));
  const valid=related.filter(s=>!s.sumiuDoLiftEm&&!s.liftCancellation&&!s.historicoSomentePosVenda
    && !/^(cancelad[oa]|inativo|anulad[oa])$/i.test(s.statusLift||"")
    && matches(bindingForSale(s))&&String(bindingForSale(s).pedidoId)===String(s.liftPedidoId));
  if(valid.length===1)return bindingForSale(valid[0]);
  if(related.length)return null; // Never replace contrary order evidence with a stale card.
  return matches(record?.manualSaleBinding)?record.manualSaleBinding:null;
}

export function confirmedFinancialLeadBinding(record, clients = []) {
  // A financial sheet is proof for its exact source, never a phone-only match
  // or a fallback over contrary/cancelled LIFT evidence.
  if(record?.manualSaleBinding?.pedidoId||record?.liftPedidoId)return null;
  const key=String(record?._rawPhone||record?.id||"").replace(/^aurora_/,"");
  const store=Number(record?.lojaAtual||record?.storeId);
  const matches=clients.filter(c=>c?.financeOnly===true&&c.financialSourceType==="lead"
    &&String(c.financialSourceId||c.leadId||"").replace(/^aurora_/,"")===key
    &&Number(c.storeId)===store&&c.stage==="closed"&&Number(c.value)>0
    &&(!c.phone||phone(c.phone)===phone(record?.telefone||record?.phone)));
  if(matches.length!==1)return null;
  const sheet=matches[0];
  return {status:"confirmed",sourcePath:`leads/${key}`,storeId:store,financialSaleId:String(sheet.id),
    saleValue:Number(sheet.value),saleDate:sheet.data_fechamento||sheet.stageDates?.closed,
    boundAt:sheet.saleConfirmedAt||sheet.financialSourceClosedAt||null};
}

export function projectConfirmedFinancialLead(record, clients) {
  const binding=confirmedFinancialLeadBinding(record,clients);
  if(!binding)return record;
  const fields={estagio:"fechou_venda",_crm_estagio:"fechou_venda",status:"venda",
    financialSaleId:binding.financialSaleId,valor_venda:binding.saleValue,
    data_fechamento:binding.saleDate,fechou_venda_em:binding.saleDate,
    proxima_data_contato:null,followUp:null};
  return Object.entries(fields).filter(([,v])=>v!==undefined)
    .reduce((result,[key,value])=>withStageProjection(result,key,value),record);
}

// Display-only projection. Existing projection metadata prevents these fields
// from leaking into ordinary form writes.
export function projectConfirmedLiftCard(moduleId, record, sales) {
  const binding=confirmedBindingForCard(moduleId,record,sales);
  if(!binding)return record;
  const saleDay=String(binding.saleDate||"").slice(0,10);
  const fields={manualSaleBinding:binding,liftPedidoId:binding.pedidoId,liftStoreId:binding.storeId,
    followUp:null,proxima_data_contato:null,
    ...(binding.boundAt?{saleConfirmedAt:binding.boundAt}:{}),
    ...(moduleId==="leads"?{estagio:"fechou_venda",_crm_estagio:"fechou_venda",status:"venda",
      ...(Number.isFinite(Number(binding.saleValue))?{valor_venda:Number(binding.saleValue)}:{}),
      ...(/^\d{4}-\d{2}-\d{2}$/.test(saleDay)?{fechou_venda_em:saleDay,data_fechamento:saleDay}:{})}:
      {stage:moduleId==="kanban"?"closed":"venda"})};
  return Object.entries(fields).reduce((result,[key,value])=>withStageProjection(result,key,value),record);
}

export function protectLeadBindingPatch(patch, previous, confirmedBinding = null) {
  const result={...patch};
  for(const key of ["manualSaleBinding","liftPedidoId","liftStoreId"])delete result[key];
  // A stale form may edit a note/date, not reopen a sale it never observed.
  for(const key of ["estagio","_crm_estagio","status"]){
    const before=key==="_crm_estagio"?previous?._crm_estagio||previous?.estagio:previous?.[key];
    if(confirmedBinding?.status==="confirmed"||previous?.manualSaleBinding?.status==="confirmed"
      ||result[key]===before)delete result[key];
  }
  return result;
}
